import { useContext, useEffect, useState } from "react";
import { AppBar, Box, Button, Toolbar } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import PieContext from "../../PieContext";
import ModalGraficas from "../modal/ModalGraficas";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import logoTRIFE from "../../assets/images/logoTRIFE.svg";
import facebook from "../../assets/images/facebook.png";
import twitter from "../../assets/images/twitter.png";
import "./menu.css";
import MobileMenu from "../../utils/controlls/MobileMenu";
import { Label } from "@material-ui/icons";

export default function Menu() {
  //#region Consts
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const [stateButton, setStateButton] = useState(false);
  const [stateModal, setStateModal] = useState(false);
  const { dataEstadistica } = useContext(PieContext);
  const { actualizaDataEstatica } = useContext(PieContext);
  //#endregion Consts

  //#region Effects
  useEffect(() => {
    setStateButton(dataEstadistica.length > 0);
  }, [dataEstadistica]);
  //#endregion Effects

  //#region Styles
  const divContenedorMenu: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: 142,
    backgroundColor: "#FFFF",
  };

  const divLogo: CSSProperties = {
    height: "98px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "left",
    backgroundColor: "white",
  };
  const imgLogo: CSSProperties = {
    width: "190px",
    height: "53px",
  };

  const toolbarStyle: CSSProperties = {
    backgroundColor: "#FFFF",
  };

  //#endregion Styles

  useEffect(() => {
    setStaticDatas();
  }, []);

  async function setStaticDatas() {
    //debugger;
    setLoader(true);
    const param2 = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    const fetch_1996_2008 = await fetch("data/1996_2008.json", param2);
    const fetch_2009_2010 = await fetch("data/2009_2010.json", param2);
    const fetch_2011 = await fetch("data/2011.json", param2);
    const fetch_2012 = await fetch("data/2012.json", param2);
    const fetch_2013_2014 = await fetch("data/2013_2014.json", param2);
    const fetch_2015 = await fetch("data/2015.json", param2);
    const fetch_2016_2017 = await fetch("data/2016_2017.json", param2);

    const json_1996_2008 = await fetch_1996_2008.json();
    const json_2009_2010 = await fetch_2009_2010.json();
    const json_2011 = await fetch_2011.json();
    const json_2012 = await fetch_2012.json();
    const json_2013_2014 = await fetch_2013_2014.json();
    const json_2015 = await fetch_2015.json();
    const json_2016_2017 = await fetch_2016_2017.json();
    actualizaDataEstatica([
      ...json_2016_2017,
      ...json_2015,
      ...json_2013_2014,
      ...json_2012,
      ...json_2011,
      ...json_2009_2010,
      ...json_1996_2008,
    ]);
    setLoader(false);
  }

  // const styleBox = {flexGrow: 1, position: "sticky", top: 0, zIndex: 1000};
  return (
    <>
      {loader ? (
        <div className="loader"></div>
      ) : (
        <div style={divContenedorMenu}>
          <Box sx={{ flexGrow: 1 }}>
            <AppBar position="fixed">
              <div style={divLogo}>
                <div style={{ width: "33%" }} className="menuDiv"></div>
                <div
                  style={{
                    width: "33%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  className="menuDiv"
                >
                  <img
                    style={imgLogo}
                    src={logoTRIFE}
                    className="logoTribunal"
                  />
                </div>
                <div
                  style={{
                    width: "33%",
                    display: "flex",
                    justifyContent: "left",
                    flexDirection: "column",
                    lineHeight: "",
                  }}
                  className="menuDiv"
                >
                  <div
                    style={{
                      color: "#24135F",
                      fontWeight: "bold",
                      fontSize: window.screen.width < 1000 ? 12 : 19,
                    }}
                    className="divNombre"
                  >
                    <div className="redes">
                      <a
                        href="https://www.facebook.com/TEPJF"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={facebook}
                          alt="logo-fb"
                          className="socialIcon"
                        />
                      </a>
                      <a
                        href="https://twitter.com/TEPJF_informa"
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={twitter}
                          alt="logo-twitter"
                          className="socialIcon"
                        />
                      </a>
                    </div>
                    Secretaría General de Acuerdos <br /> Unidad de Estadística
                    e Información Jurisdiccional
                  </div>
                </div>
              </div>
              <Toolbar variant="dense" style={{ justifyContent: "center" }}>
                <div className="webMenu">
                  <Button
                    variant="text"
                    onClick={() => {
                      if (
                        localStorage.getItem("deshabilita") === "0" ||
                        localStorage.getItem("deshabilita") === null
                      )
                        navigate("/Inicio");
                      //navigate("/Inicio");
                    }}
                    className="button"
                  >
                    <strong>INICIO</strong>
                  </Button>
                  {/* <Button
                variant="text"
                onClick={() => {
                  if(!localStorage.getItem("deshabilita")) navigate("/AcercaDe");
                }}
                className="button"
              >
                <strong>ACERCA DE</strong>
              </Button> */}
                  <Button
                    variant="text"
                    onClick={() => {
                      window.open("https://www.te.gob.mx/estadisticas/");
                    }}
                    className="button"
                  >
                    <strong>ESTADÍSTICA JUDICIAL</strong>
                  </Button>
                  <Button
                    variant="text"
                    onClick={() => {
                      if (
                        localStorage.getItem("deshabilita") === "0" ||
                        localStorage.getItem("deshabilita") === null
                      )
                        navigate("/Reporteador/1");
                      //navigate("/Reporteador");
                    }}
                    className="button"
                  >
                    <strong>PORTAL INTERACTIVO DE ESTADÍSTICA</strong>
                  </Button>
                </div>
                <div className="mobileMenu">
                  <MobileMenu />
                </div>
              </Toolbar>
            </AppBar>
          </Box>
          {stateModal ? (
            <ModalGraficas cerrarModal={() => setStateModal(false)} />
          ) : null}
        </div>
      )}
    </>
  );
}
